/* Картинки видов персонажа («Вид персонажа» и герой экрана). В карточке персонажа (avatarCatalog.details) skins[].image_url —
   ключ хранилища live-avatar/…, а не адрес (vc-service FillSkinsAsync): картинку отдаёт авторизованный BFF
   GET /app/catalog/avatars/{id}/image?skin_id= (MessagingStudioAvatarController). Она идёт в общий кэш картинок студии
   (studio-artwork-cache) без AbortSignal экрана: blob-URL общий, уход одного экрана не обрывает загрузку другим.
   Другие значения (адрес https) показываются как есть — их ImageAsync не отдаёт (503 avatar_media_unavailable). */
import { useEffect, useState } from 'react';
import { api, endpoints } from '../../../api';
import type { AvatarCard } from '../../../api/avatar-catalog';
import { leaseArtwork } from '../studio-artwork-cache';

export const isSkinKey = (value: string) => value.startsWith('live-avatar/');

/** blob-URL картинок видов персонажа по id вида; пока картинка не пришла или не загрузилась — записи нет. */
export function useCircleSkinArt(character: AvatarCard | null, enabled: boolean): Record<number, string> {
  const owner = character && enabled ? `${character.id}:${character.version}` : '';
  const [art, setArt] = useState<{ owner: string; images: Record<number, string> }>({ owner: '', images: {} });
  useEffect(() => {
    if (!character || !enabled) return;
    const epoch = endpoints.sessionEpoch?.() ?? 0;
    const key = `${character.id}:${character.version}`;
    let live = true;
    const leases = character.skins
      .filter(skin => isSkinKey(skin.image_url))
      .map(skin => {
        const lease = leaseArtwork(epoch, `${character.id}:s${skin.id}:${character.version}`, () =>
          api.download(`/app/catalog/avatars/${character.id}/image?skin_id=${skin.id}`),
        );
        lease.url.then(
          url => {
            if (live) setArt(current => ({ owner: key, images: { ...(current.owner === key ? current.images : {}), [skin.id]: url } }));
          },
          () => {},
        );
        return lease;
      });
    return () => {
      live = false;
      leases.forEach(lease => lease.release());
    };
  }, [character, enabled]);
  return art.owner === owner ? art.images : {};
}
